import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const VOUCHER_SP_CONSUMO_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/voucher-sp-consumo`;

const VoucherSuperpartnerCorsistaService = {

    /**
     * Consuma un voucher dal magazzino del Superpartner per iscrivere un corsista.
     * @param {object} data - Dati necessari per l'operazione.
     */
    consume(data) {
        const url = `${VOUCHER_SP_CONSUMO_ENDPOINT}/consume`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    getVoucherStock(data) {
        const url = `${VOUCHER_SP_CONSUMO_ENDPOINT}/get-stock`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    }
};

export default VoucherSuperpartnerCorsistaService;